<script>
    import { onMount, createEventDispatcher } from 'svelte';
    import { fade } from 'svelte/transition';
		import { getServer, fetchData, getLocalServer, loadCacheIndex, hasCache, getCache } from '../shared/utils/Data.svelte';
		import { sortByName, ignoreCaseSort } from '../shared/utils/Sort.svelte';
    import Node from '../shared/sidebar/Node.svelte';
    import { person, logOut, addCircleOutline, cube, map, grid, headset, videocam, document, link, bookmark, refresh, image, download, informationCircleOutline } from 'ionicons/icons/index.mjs';
    export let project;
		export let settings;
		export let isPublic;
		export let tooltips;
		console.log(project.tree.tables)
		let state = {
        media: {},
        scene: {}
    }
		let pubParam = isPublic ? "?public" : "";
    const dispatch = createEventDispatcher();
    function sendMessage(message) {
			dispatch('message', message);
    }
		function openHandler(type, section) {
      state[type][section] = !state[type][section]
    }
</script>

<div id="stage" in:fade>
		{#if project.id != "0"}
    <div class="navbar">
        <div class="navbar-section">
            <div class="navbar-brand">
							{project.name}
						</div>
        </div>
    </div>
        <div class="container pl-2 pr-2 mb-5" in:fade>
            <div class="columns">
                <div class="column col-sm-12 col-6">
                    <div class="tile tile-centered pr-2 pl-2">
                        <div class="tile-content">
                            <div class="divider" data-content="PROJECT TREE"></div>
                        </div>
                    </div>
                    {#if Object.keys(project.tree).length > 0}
											{#each Object.keys(project.tree) as section}
												{#if section != "tables"}
													{#if project.tree[section].child_count == 0}
															<ul class="menu menu-nav">
																	<div class="tile tile-centered">
																			<div class="tile-content">
																					<li class="menu-item">{project.tree[section].name}</li>
																			</div>
																			<div class="tile-action">
																					{#if project.tree[section].type == "map"}
																							<a href={"/maps/" + project.tree[section].id + pubParam} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Map">
																									<i class="svg">{@html map.md}</i>
																							</a>
																					{:else if project.tree[section].type == "scene"}
																							<a href={"/scenes/" + project.tree[section].id + pubParam} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Scene">
																									<i class="svg">{@html cube.md}</i>
																							</a>
																					{:else if project.tree[section].type == "table"}
																							<a href={"/tables/" + project.tree[section].id + pubParam} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Table">
																									<i class="svg">{@html grid.md}</i>
																							</a>
																					{/if}
																			</div>
																	</div>
															</ul>
													{:else}
															<Node tooltips={tooltips} node={project.tree[section]} isPublic={isPublic} />
													{/if}
												{/if}
											{/each}
											{#if project.tree.tables && project.tree.tables.length > 0}
												<div class="tile tile-centered pr-2 pl-2">
														<div class="tile-content">
																<div class="divider" data-content="TABLES"></div>
														</div>
												</div>
												{#each project.tree.tables as table}
													<ul class="menu menu-nav">
															<div class="tile tile-centered">
																	<div class="tile-content">
																			<li class="menu-item">{table.name}</li>
																	</div>
																	<div class="tile-action">
																			<a href={"/tables/" + table.id + pubParam} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Table">
																				<i class="svg">{@html grid.md}</i>
																			</a>
																	</div>
															</div>
													</ul>
												{/each}
											{/if}
                    {/if}
                </div>
                <div class="column col-sm-12 col-6">
                    <div class="tile tile-centered pl-2">
                        <div class="tile-content">
                            <div class="divider" data-content="PROJECT MEDIA"></div>
                        </div>
						<div class="tile-action">
							{#if project.role > 1}
								<button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Add Media" on:click={(e) => {
									e.currentTarget.blur();
										sendMessage({
											type: "modal",
											data: {
												view: "mediaUpload",
												id: project.id,
												role: project.role
											}
										})
									}}>
									<i class="svg">{@html addCircleOutline.md}</i>
								</button>
							{/if}
						</div>
                    </div>
					{#if Object.keys(project.media).length > 0}
						{#each Object.keys(project.media).sort(ignoreCaseSort) as section}
							<div class="accordion" in:fade>
								{#if state.media[section]}
										<input type="checkbox" id={section + "-media"} on:change={(e) => {openHandler("media", section)}} name="accordion-checkbox" hidden checked>
								{:else}
										<input type="checkbox" id={section + "-media"} on:change={(e) => {openHandler("media", section)}} name="accordion-checkbox" hidden>
								{/if}
								<label class="accordion-header" for={section + "-media"}>
									<div class="tile tile-centered">
										<div class="tile-icon">
											<div class="example-tile-icon">
												{#if state.media[section]}
														<i class="icon icon-arrow-down centered"></i>
												{:else}
														<i class="icon icon-arrow-right centered"></i>
												{/if}
											</div>
										</div>
										<div class="tile-content">
											<div class="tile-title">{section}</div>
										</div>
									</div>    
								</label>
								<div class="accordion-body">
									<ul class="menu menu-nav">
										{#if Object.values(project.media[section]).length > 0}
											{#each Object.values(project.media[section]).sort(sortByName) as item}
												<div class="tile tile-centered">
													<div class="tile-icon">
														<div class="type-icon">
															{#if item.type == "link"}
																<i class="svg">{@html link.md}</i>
															{:else if item.type == "download"}
																<i class="svg">{@html download.md}</i>
															{:else if item.type == "pdf" || item.type == "document"}
																<i class="svg">{@html bookmark.md}</i>
															{:else if item.type == "image"}
																<i class="svg">{@html image.md}</i>
															{:else if item.type == "360"}
																<i class="svg">{@html refresh.md}</i>
															{:else if item.type == "audio"}
																<i class="svg">{@html headset.md}</i>
															{:else if item.type == "video"}
																<i class="svg">{@html videocam.md}</i>
															{:else}
																<i class="svg">{@html document.md}</i>
															{/if}
														</div>
													</div>
													<div class="tile-content">
														<li class="menu-item">
															{#if settings.newTab && (item.type == "link" || item.type == "pdf")}
																<a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
															{:else if item.type == "download"}
																{#if window.platform == "Windows"}
																	<button class="btn btn-link" on:click|stopPropagation={async (e) => {
																		e.currentTarget.blur();
																		let [res, err]  = await fetchData(getLocalServer() + "/core", {
																			method: "POST",
																			headers: {
																					'Accept': 'application/json',
																					'Content-Type': 'application/json'
																			},
																			body: JSON.stringify({
																				url: item.uri
																			})
																		});
																		if (err || !res.found) {
																				window.open(item.uri, "_blank");
																		}
																	}}>
																	{item.name}
																	</button>
																{:else}
																	<a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
																{/if}
															{:else}
																<button class="btn btn-link"
																on:click|stopPropagation={(e) => {
																	e.currentTarget.blur();
																	sendMessage({
																		type: "modal",
																		data: {
																			view: "mediaView",
																			media: item
																		}
																	})
																}}>{item.name}</button>
															{/if}
														</li>
													</div>
													<div class="tile-action">
														<button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Details" on:click|stopPropagation={(e) => {
																	e.currentTarget.blur();
																	sendMessage({
																		type: "modal",
																		data: {
																			view: "mediaUpload",
																			id: project.id,
																			group: section,
																			media: item,
																			role: project.role
																		}
																	})
																}}>
																<i class="svg">{@html informationCircleOutline.md}</i>
														</button>
													</div>
												</div>
											{/each}
										{/if}
									</ul>
								</div>
							</div>
						{/each}
					{/if}
                </div>
            </div>
        </div>
    {/if}
</div>

<style>
	#stage {
        width: 100%;
    }
    .navbar {
        position: sticky;
        top: 0;
        z-index: 99;
        background: #efefef;
        padding: 0.2rem 0.2rem 0.2rem 2rem;
    }
    .accordion .accordion-header {
		cursor: pointer;
		user-select: none;
		height: 1rem;
		padding: 0.2rem 0rem 0.2rem 0.75rem;
	}
	.accordion-body {
		padding-left: 1rem;
        margin: 0.4rem 0 0 0;
	}
	.menu {
        padding: 0 0 0 0.8rem;
    }
    .menu .menu-item {
        padding: 0;
    }
	.menu .menu-item > button {
		border: 0;
	}
	::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
	}
	.menu-item a {
		text-align: left;
		margin: 0;
		padding-left: 0.4rem;
	}
	.menu-item a:hover, .menu-item a:visited {
		background-color: transparent;
	}
	.menu .menu-item > a:focus, .menu .menu-item > a:hover {
		background-color: transparent;
	}
	.type-icon {
		display: inline-block;
		font-size: 0.8rem;
		height: 1.8rem;
		width: 1.8rem;
		line-height: 1.2rem;
		outline: none;
		padding: 0.4rem 0.4rem;
		text-align: center;
	}
</style>